export default __webpack_public_path__ + "static/media/monthly_1.b64da584.png";